var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pesquisasClinicas',{attrs:{"portal":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }